import React, {useEffect} from 'react';
import { strings } from 'src/localization';
import css from './VehLayout.module.scss';
import UpcomingApptCard from 'src/components/UpcomingApptCard/containers/UpcomingApptCard';
import AddApptCard from 'src/components/AddApptCard/containers/AddApptCard';
import ROHistoryCard from '../ROHistoryCard/containers/ROHistoryCard';
import ManuRecalls from './ManuRecalls/ManuRecalls';
import CurrentRepairCard from '../CurrentRepairCard/containers/CurrentRepairCard';
import { IAppointmentState } from 'src/store/states';
import PrevRecomm from './PrevRecomm/PrevRecomm';
import { CustMode } from 'src/enums';
import { IView, ScrollBar } from '@framework-controls/core';
import { SpecData, RecallData, MCData, ascPageviewInput, Recom, ROHistory, VehicleRec } from 'src/models';
import MaintContractVehLayout from './MaintContractVehLayout/MaintContractVehLayout';
import { ComponentMapIds } from '../map';
import { ascPageview } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';
import { getProviderId, getSdMileage, sendSdEvent } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';

export interface IPropState {
    appointment: IAppointmentState,
    custMode: CustMode,
    specInfo?: SpecData,
    recallData: RecallData,
    MCData: MCData,
    lexusMCLaunched: string,
    toyotaMCLaunched: string,
    theme: string,
    locale: string,
    additionalServicesBuilt: boolean,
    roHistoryBuilt: boolean,
    mainPaneViewOrder: IView[],
    prevRecomSvcs: Recom[],
    roHistory: ROHistory[],
    vehicles: VehicleRec[],
    selectedVehicle?: string;
    countryCode: string;
    addLogEntry: (action: string, screen: string, details: string) => void;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    sessionId: string;
    identityVerified: boolean;
}
//  This screen is a WIP.  It mostly exists of cards that are in various
//  States of development
const VehLayout = (props: IPropState) => {
    const isSDAnalyticsEnabled =
        props.specInfo?.toyotaTrackingFlag === 'Y' ||
        props.specInfo?.lexusTrackingFlag === 'Y' ||
        props.specInfo?.mbzTrackingFlag === 'Y' ||
        props.specInfo?.mazdaCATrackingFlag === 'Y' ||
        props.specInfo?.vwTrackingFlag === 'Y';

    useEffect(() => {
        props.addLogEntry('Screen Entry', 'VehLayout', '');
    }, [
        props.addLogEntry,
    ]);

    useEffect(() => {
        const currentPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;
        if (currentPane === ComponentMapIds.VehLayout) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
            if (isSDAnalyticsEnabled) {
                sendSdEvent('scheduleServiceVehicleIndicated', {
                    scheduleServiceSessionId: props.sessionId,
                    scheduleServiceProvider: getProviderId(props.specInfo, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched),
                    scheduleServiceVehicleMake: props.appointment.ApptVeh.make,
                    scheduleServiceVehicleMileage: getSdMileage(props.appointment.ApptVeh.mileage),
                    scheduleServiceVehicleModel: props.appointment.ApptVeh.model,
                    scheduleServiceVehicleVin: props.appointment.ApptVeh.vin,
                    scheduleServiceVehicleYear: props.appointment.ApptVeh.vehYr,
                });
                sendSdEvent('scheduleServiceSelectionShown', {
                    scheduleServiceSessionId: props.sessionId,
                    scheduleServiceProvider: getProviderId(props.specInfo, props.toyotaMCLaunched,
                        props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched),
                    scheduleServiceVehicleMake: props.appointment.ApptVeh.make,
                    scheduleServiceVehicleMileage: getSdMileage(props.appointment.ApptVeh.mileage),
                    scheduleServiceVehicleModel: props.appointment.ApptVeh.model,
                    scheduleServiceVehicleVin: props.appointment.ApptVeh.vin,
                    scheduleServiceVehicleYear: props.appointment.ApptVeh.vehYr,
                });
            }
        }
    // eslint-disable-next-line @reynolds/exhaustive-deps
    }, [props.mainPaneViewOrder]);

    const maintMake = props.appointment.ApptVeh.make.toLowerCase().split(' ')[0];
    // locale
    // const showMaintContract = (props.locale === 'en-US' && ((props.toyotaMCLaunched && maintMake === 'toyota') ||
    const showMaintContract = (props.countryCode === 'US' &&
        (((props.toyotaMCLaunched || props.toyotaTDMCLaunched) && maintMake === 'toyota') ||
        ((props.lexusMCLaunched || props.lexusTDMCLaunched) && maintMake === 'lexus')));

    const summaryTitleStyles = classNames(
        css.summaryTitle,
        {
            [css.summaryTitleBMW]: props.theme === 'bmw',
            [css.summaryTitleFord]: props.theme === 'ford',
            [css.summaryTitleMazda]: props.theme === 'mazda',
            [css.summaryTitleAcura]: props.theme === 'acura',
            [css.summaryTitleGenesis]: props.theme === 'genesis',
            [css.summaryTitleLexus]: props.theme === 'lexus',
        },
    );

    return (
        <ScrollBar scrollVertical>
            <div className={css.vehLayout}>
                <h4 className={summaryTitleStyles}>
                    {props.identityVerified ?
                        `${props.appointment.ApptCust.custFirstName},` :
                        strings.WelcomeBack}
                </h4>
                <div id='vehStatement' className={props.theme==='bmw' ? css.subHeadingBMW : ''}>
                    {`${strings.WhatsHappening} ` +
                    `${props.appointment.ApptVeh.model ? props.appointment.ApptVeh.model :
                        `${strings.Vehicle.toLowerCase()}`}.`}
                </div>
                <CurrentRepairCard />
                <UpcomingApptCard />
                {props.specInfo?.showOEMRecall ?
                    <ManuRecalls
                        model={props.appointment.ApptVeh.model}
                        make={props.appointment.ApptVeh.make}
                        year={props.appointment.ApptVeh.vehYr}
                        custMode={props.custMode}
                        vin={props.appointment.ApptVeh.vin}
                        recallData={props.recallData}
                        theme={props.theme}
                        vehicles={props.vehicles}
                        selectedVehicle={props.selectedVehicle}
                    /> : null}
                {showMaintContract ? <MaintContractVehLayout
                    model={props.appointment.ApptVeh.model}
                    make={props.appointment.ApptVeh.make}
                    year={props.appointment.ApptVeh.vehYr}
                    custMode={props.custMode}
                    vin={props.appointment.ApptVeh.vin}
                    MCData={props.MCData}
                    toyotaMCLaunched={props.toyotaMCLaunched}
                    lexusMCLaunched={props.lexusMCLaunched}
                    vehicles={props.vehicles}
                    selectedVehicle={props.selectedVehicle}
                    theme={props.theme}
                /> : null}
                <PrevRecomm
                    custMode={props.custMode}
                    theme={props.theme} />
                <AddApptCard />
                <ROHistoryCard />
                <div id='ROHistCardtest' />
            </div>
        </ScrollBar>
    );
};

export default VehLayout;